export default __webpack_public_path__ + "static/media/card.b53608e5.jpeg";